// packages
import { createFeed } from './stores.js';
import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

// components
import PendingResultsModal from './components/PendingResultsModal.svelte';

// URL for alpha and pub
import { STATE_URL } from './constants.js';

async function main() {
  // must match `page` for this box in _data/embeds/custom.json
  const pageLevel = 'ca';

  const element = findElementByIdInShadowDom(`pendingresultsmodal-${pageLevel}`);
  if (!element) return;

  let page = element.dataset.page;
  let feed = await createFeed(STATE_URL);

  renderSvelteComponent(PendingResultsModal, element, {
    feed,
    page,
  });
}

main().catch(console.error);
